module.exports = __webpack_public_path__ + "img/profile-edit.95efd25f.svg";